import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRemovePointing } from "./hooks/useRemovePointing";


export default /*#__PURE__*/_defineComponent({
  __name: 'RemovePointing',
  props: {
    pointingId: {}
  },
  emits: ["done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { loading, removePointing } = useRemovePointing({ props, emit });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(_component_Button, {
    label: _ctx.$t('remove'),
    icon: "pi pi-trash",
    class: "p-button-text p-button-danger",
    loading: _unref(loading),
    onClick: _unref(removePointing)
  }, null, 8, ["label", "loading", "onClick"]))
}
}

})